import { TypographyP2 } from '@heidi/design-system/typography';
import { FormattedMessage } from 'react-intl';
import { appleIapMessages } from './apple-iap-info-text.messages';

export interface AppleIapInfoTextProps {
  className?: string;
}

export const AppleIapInfoText = ({ className }: AppleIapInfoTextProps) => {
  return (
    <TypographyP2 className={className}>
      <FormattedMessage {...appleIapMessages.manageAccount} />
    </TypographyP2>
  );
};
